import { api } from './client';

/**
 * Character Dossier API — the eight PR #411 endpoints under
 * /api/entities/{id}/dossier* and /api/dossier-entries/{id}*.
 * Writer-facing (normal auth), not admin/flag-gated.
 */
export const dossiersApi = {
  // GET active dossier view: { dossier, entity, entries[], relationships[] } or null
  get: (entityId) => api.get(`/entities/${entityId}/dossier`),

  // Deterministic render: { public, secret }
  injectionForm: (entityId) => api.get(`/entities/${entityId}/dossier/injection-form`),

  // Generate proposed entries: { dossier_id, proposed[] }
  generate: (entityId) => api.post(`/entities/${entityId}/dossier/generate`, {}),

  // Refresh-with-diff: { dossier_id, diff[], reused? }
  // force:true is Regenerate — always pays. Unchanged Refresh reuses the prior extract.
  refresh: (entityId, { model, force } = {}) =>
    api.post(`/entities/${entityId}/dossier/refresh`, { model, force }),

  // Confirm per-entry (entry_ids) or per-section (half|field): { confirmed: N }
  confirm: (entityId, { entryIds = null, half = null, field = null } = {}) =>
    api.post(`/entities/${entityId}/dossier/confirm`, {
      entry_ids: entryIds,
      half,
      field,
    }),

  // Inline edit -> the edited/superseding entry
  edit: (entryId, content) =>
    api.patch(`/dossier-entries/${entryId}`, { content }),

  // Accept a refresh-proposed entry -> confirmed entry
  accept: (entryId) => api.post(`/dossier-entries/${entryId}/accept`, {}),

  // Reject a refresh-proposed entry -> { rejected: id }
  reject: (entryId) => api.post(`/dossier-entries/${entryId}/reject`, {}),
};

export default dossiersApi;
